import Lightbox from "./Lightbox.js";

export default class AutoSizeImage extends Lightbox {

    constructor(element) {
        super(element);
        this.width = null;
        this.height = null;
        this.aspectRatio = null;
        this.imgUrl = null;
        this.previewholder = null;
        this.imageElement = null;
        this.$imageElement = null;

        this.loadInvisible = false;

        this.currentImageWidth = 0;
        this.imageQuality = 1;
        this.customLoad = false;
        this.lightbox = false;

        this.imgLoadListener = null;
        this.preloadListener = null;
        this.resizeListener = null;

        this.visibility = -1;
        this.minVisibility = 0.6;

        this.init();
    }

    initListener() {
        let mySelf = this;

        this.imgLoadListener = function () {
            mySelf.handleImageLoad();
        }

        this.preloadListener = function (event, data) {
            if (data != undefined) {
                if (data.preloadwidth != undefined) {
                    mySelf.loadImage(data.preloadwidth, data.quality);
                }
            }
        }

        this.resizeListener = function () {
            mySelf.loadImage();
        }

        $(document).on("content:resized", this.resizeListener);
        this.$element.on("content:preload", this.preloadListener);
        if (this.lightbox) {
            this.$element.on('click', this.openLightboxListener);
        }

    }

    init() {

        super.init();

        this.aspectRatio = this.$element.attr("data-aspectratio");
        this.imgUrl = this.$element.attr("data-img-url");

        const customLoad = this.$element.data("custom-load");
        if (customLoad != undefined && customLoad) {
            this.customLoad = true;
        }

        let imageQuality = this.$element.attr("data-img-quality");
        if (imageQuality != undefined) {
            this.imageQuality = imageQuality;
        }

        let loadInvisible = this.$element.attr("data-load-invisible");
        if (loadInvisible != undefined) {
            if (loadInvisible == 1) {
                this.loadInvisible = true;
            }
        }

        let $previewholder = this.$element.find('[data-type="previewholder"]');
        if ($previewholder != undefined) {
            this.previewholder = $previewholder;
        }

        let lightbox = this.$element.attr('data-lightbox');
        if (lightbox != undefined && lightbox == true) {
            this.lightbox = true;
        }

        this.initListener();

        $(document).trigger("IntersectionObserver:observe", this.element);

        if (!customLoad) {
            this.loadImage();
        }

    }

    handleImageLoad() {
        this.previewholder.addClass("hidden");
        this.$imageElement.removeClass("hidden");
        this.$imageElement.off("load", this.imgLoadListener);
    }

    loadImage(preloadWidth = 0, quality = 0) {

        if (quality != 0) {
            this.imageQuality = quality;
        }
        if (this.$element == undefined) {
            return;
        }

        this.width = this.$element.innerWidth();
        this.height = this.$element.innerHeight();

        if (preloadWidth > 0) {
            this.createImage();
            this.setSizes(preloadWidth);

        } else if (this.width > 0) {
            if (this.loadInvisible) {
                this.createImage();
                this.setSizes(this.width);
            } else {
                if (this.visibility >= this.minVisibility) {
                    this.createImage();
                    this.setSizes(this.width);
                    $(document).trigger("IntersectionObserver:unobserve", this.element);
                } else if (this.visibility == -1) {
                    if (this.isVisible($(window), this.$element, 60, 1, 60)) {
                        this.createImage();
                        this.setSizes(this.width);
                    }
                } else {
                    if (this.$imageElement != null) {
                        this.setSizes(this.width);
                    }
                }
            }
        }
    }

    unloadImage() {
        if (this.$imageElement != null) {
            this.$imageElement.off("load", this.imgLoadListener);
            this.$imageElement.remove();
            this.imageElement = null;
            this.$imageElement = null;
            this.currentImageWidth = 0;
        }
    }

    handleVisibilityChange(visibility) {
        this.visibility = visibility;

        if (this.visibility > 0) {
            this.loadImage(0, 0);
        } else {
            // this.unloadImage(); // Vorerst wird das Bild nicht entfernt
        }


    }

    createImage() {
        if (this.imageElement == null) {
            this.imageElement = new Image();
            this.$imageElement = $(this.imageElement);
            this.$imageElement.addClass("hidden");
            this.$imageElement.on("load", this.imgLoadListener);
            this.$element.append(this.imageElement);
        }
    }


    setSizes(elementWidth) {
        let availableHeight = document.documentElement.clientHeight; // clientHeight Wichtig für die iPhones
        let maxHeight = Math.floor((availableHeight * 0.80));
        let imageWidth = Math.floor(elementWidth);
        let imageHeight = Math.ceil(imageWidth / this.aspectRatio);

        if (imageHeight > maxHeight) {
            imageWidth = Math.ceil(maxHeight * this.aspectRatio);
            imageHeight = maxHeight;
        }

        if (this.currentImageWidth < imageWidth) {
            // Es wurde kein, oder kleineres Bild geladen, es soll ein Bild vom Server abgefragt werden, ansonsten wird nur das vorhandene, große Bild skaliert

            this.currentImageWidth = imageWidth;

            let loadWidth = imageWidth * devicePixelRatio;

            let step = 10;
            if (loadWidth > 1000) {
                step = 100;
            } else if (loadWidth > 400) {
                step = 50;
            } else if (loadWidth > 200) {
                step = 30;
            } else if (loadWidth > 100) {
                step = 20;
            }
            loadWidth = Math.ceil(loadWidth / step) * step;

            if (loadWidth > 2000) {
                loadWidth = 2000;
            }

            let newImgUrl = this.imgUrl + "&s=" + loadWidth;

            this.$imageElement.attr("src", newImgUrl);
        }

        this.$imageElement.attr("width", imageWidth);
        this.$imageElement.attr("height", imageHeight);
        this.$imageElement.css("width", imageWidth);
        this.$imageElement.css("height", imageHeight);

        this.$element.css("height", imageHeight);

    }

    loadLightboxContent() {
        const imageData = {
            width: this.$element.attr('data-width'),
            height: this.$element.attr('data-height'),
            aspectratio: this.$element.attr('data-aspectratio'),
            imgUrl: this.$element.attr('data-img-url'),
            customLoad: false,
            galleryItem: false,
        };

        return this.templatesWorker.loadAutoSizeImageTemplate(
            imageData,
            this.imageQuality,
            false,
            false,
            false,
            false,
            true
        );
    }

    destroyListener() {
        super.destroyListener();

        if (this.$imageElement != null) {
            this.$imageElement.off("load", this.imgLoadListener);
            this.$element.off("content:preload", this.imgLoadListener);
        }
        $(document).off("content:resized", this.resizeListener);
        this.$element.off("content:preload", this.preloadListener);
        $(document).trigger("IntersectionObserver:unobserve", this.element);
    }
}